import { create } from 'zustand';
import { api, ApiError, type Me } from '@/sync/api';

export type AccountStatus = 'unknown' | 'guest' | 'loggedIn' | 'offline';

interface AccountState {
  status: AccountStatus;
  me: Me | null;
  syncing: boolean;
  lastSyncAt: number | null;
  syncError: string | null;
  refresh: () => Promise<void>;
  logout: () => Promise<void>;
  set: (patch: Partial<Pick<AccountState, 'syncing' | 'lastSyncAt' | 'syncError'>>) => void;
}

/** Guest mode works fully locally; login (Strava) unlocks sync, Strava upload and multiplayer (SPEC §11.1). */
export const useAccount = create<AccountState>((set) => ({
  status: 'unknown',
  me: null,
  syncing: false,
  lastSyncAt: null,
  syncError: null,
  async refresh() {
    try {
      const me = await api.me();
      set({ status: 'loggedIn', me });
    } catch (err) {
      set({ status: err instanceof ApiError && err.status === 401 ? 'guest' : 'offline', me: null });
    }
  },
  async logout() {
    await api.logout().catch(() => undefined);
    set({ status: 'guest', me: null });
  },
  set: (patch) => set(patch),
}));

export function isLoggedIn(): boolean {
  return useAccount.getState().status === 'loggedIn';
}
